export type LocationState = {
  page?: {
    pathname: string;
    search?: string;
    state: LocationState;
  };
  isMainPage?: boolean;
  placeholderImage?: string;
};

export enum PageRoutes {
  MyAccount = '/my-account',
  More = '/more',
  List = '/list/:slug',
  ContentCollection = '/lists/:slug',
  Login = '/my-account/login',
  Search = '/search',
  SearchFilter = '/search/filter',
  RangeFilter = '/search/range/:id/:type'
}

export const SPECIAL_COLLECTION_SLUGS = {
  continueWatching: 'continue-watching',
  myList: 'my-list',
  myContent: 'my-content'
} as const;

export enum CardRoutes {
  SeriesCard = '/media/series/:slug',
  MovieCard = '/media/movie/:slug',
  Collection = '/collection/:slug'
}

export type ButtonProps = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;
export type InputProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;
export type AnchorProps = React.DetailedHTMLProps<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
>;

export type DeepPartial<T> = {
  [P in keyof T]?: DeepPartial<T[P]>;
};

// Matches the web client's surfaces for cross-platform analytics aggregation,
// plus 'recommendations' (a TV-only paginated shelf). purchases/notify-me/
// search/collection are web-only on TV — kept for type parity, not wired.
export type PaginationSurface =
  | 'collection'
  | 'content-list'
  | 'content-collection'
  | 'purchases'
  | 'favorites'
  | 'continue-watching'
  | 'entitlements'
  | 'notify-me'
  | 'search'
  | 'recommendations';
